import { Author } from '@fable/types'
import { PersonDetailContent } from './PersonDetailContent'
import { Navigate, useLocation } from 'react-router-dom'
import { getSlug } from 'utils'
import { useQuery } from 'react-query'
import { get } from '@fable/api'
import { useErrorModal } from 'hooks'
import { Loader, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { stripHtml } from '@fable/utils'

const AuthorDetailPage = () => {
  const { colors } = useTheme()
  const location = useLocation()
  const slug = getSlug(location.pathname)

  const { data, isLoading, error } = useQuery(
    ['author'],
    async () => await get(`/authors/${slug}/`)
  )

  useErrorModal(error as Error)

  if (isLoading) {
    return (
      <Loader
        className={css`
          height: 100vh;
        `}
      />
    )
  }

  const author = data?.data as Author

  if (!author) return <Navigate to="/404" />

  return (
    <PersonDetailContent
      name={author.name}
      biography={
        <Text type="body" sizing="L" color={colors.uiGraphiteLight}>
          <span dangerouslySetInnerHTML={{ __html: author.biography }} />
        </Text>
      }
      image={author.image || ''}
      books={author.books}
      seoDescription={stripHtml(author.biography)}
      role="Author"
    />
  )
}

export default AuthorDetailPage
